import React from 'react'

export default class BlockSumFields extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            block: this.props.block,
            data: null,
            loading: false,
            pager: null,
            blockSettings: this.props.block ? this.props.block.settings : null,
            sumField: null,
            pageError: false,
        }
    }

    fetchSumField() {
        if (!this.props.block?.settings?.sum_field) {
            this.setState({ sumField: null })
            return
        }

        let api = this.props.kedo.api()

        api.get(
            api.getDefDossierDefFieldEndpoint(
                this.props.block.settings.sum_field
            )
        ).then((response) => {
            this.setState({ sumField: response.data })
        })
    }

    fetchData() {
        let environment = this.props.kedo.env().getEnvironment()
        if (!environment) {
            return
        }

        if (!this.props.block.id) {
            return
        }

        this.fetchSumField()

        let api = this.props.kedo.api()
        let params = { params: {} }

        if (this.props.dossier && this.props.dossier.id) {
            params.params.dossier = this.props.dossier.id
            params.params.dossier = this.props.dossier.id
            params.params.linkId = this.props.link
        }
        this.setState({ loading: true })

        api.get(
            api.getMyPageBlockEndpoint(this.props.block.id) + '/data',
            params
        ).then((response) => {
            this.setState({
                loading: false,
                data: response.data.result,
            })
        })
    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.block?.id !== this.props.block?.id ||
            prevProps.block?.settings?.sum_field !==
                this.props.block?.settings?.sum_field
        ) {
            this.fetchData()
        }
    }

    getDecimalInfo() {
        let dataFieldDecimals = this.state.sumField?.settings?.decimals
        let baseFieldDecimals =
            this.state.sumField?.def_field?.settings?.decimals
        let decimals = dataFieldDecimals ?? baseFieldDecimals

        if (
            decimals === null ||
            typeof decimals === 'undefined' ||
            decimals === ''
        ) {
            decimals = null
        } else {
            decimals = parseInt(decimals, 10)
            decimals = Number.isNaN(decimals) ? null : decimals
        }

        return {
            dataFieldDecimals,
            baseFieldDecimals,
            decimals,
        }
    }

    renderData(data) {
        if (data === null || typeof data === 'undefined' || data === '') {
            return ''
        }

        let decimalInfo = this.getDecimalInfo()
        let numberValue = parseFloat(data)
        let displayValue = data

        if (!Number.isNaN(numberValue) && decimalInfo.decimals !== null) {
            displayValue = numberValue.toFixed(decimalInfo.decimals)
        }

        return displayValue
    }

    render() {
        return (
            <div
                style={{ backgroundColor: '#dee2e6 !important' }}
                className={'kedo-block card-sum-fields card col-md-12'}
            >
                {this.props.getBlockHeader ? this.props.getBlockHeader() : null}
                <h1>{this.renderData(this.state.data)}</h1>
            </div>
        )
    }
}
